import React, { ReactNode } from "react"

import './modal.css';

export default function Modal({ children, enabled = true }: ModalProps) {
    if (!enabled)
        return <></>

    return <>
        <div className='modal'>
            {children && <div className='content'>{children}</div> || false}
        </div>
    </>
}

export type ModalProps = {
    children?: ReactNode
    enabled?: boolean
}
